var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',_vm._b({attrs:{"to":"#"},nativeOn:{"click":function($event){return _vm.handleLinkClick.apply(null, arguments)}}},'router-link',[_vm.$props, _vm.$attrs],false),[_vm._v(_vm._s(_vm.label)+" "),(_vm.icon)?_c('v-icon',[_vm._v(_vm._s(_vm.icon))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }